// extracted by mini-css-extract-plugin
module.exports = {"editor":"wysiwyg_editor__2yl9P","editorContainer":"wysiwyg_editorContainer__3Ctw9"};